import { createContext } from 'react'

export const TermsCondContext = createContext()
